import UserProfile from '../../../lms-shared/UI/UserProfile'
import classes from './Participants.module.css'
import defaultAvatar from '../../../../assests/user-profile/default-avatar.png'
import { useSelector } from 'react-redux';
import { onKeyDown } from '../../../../service';

const Participants = ({ data, currentParticipant, setCurrentParticipant }) => {
    const user = useSelector(state => state.auth.user);
    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.ParticipantsWarrper}>
            <div className={classes.ParticipantsContainer}>
                {data && data.map((p, i) =>
                    <div title={`${p.user.firstName} ${p.user.lastName} ${user.id == p.user.id ? `(${texts.me})` : ''}`} key={i} className={`${classes.Participant} ${currentParticipant === p.id && classes.Selected}`} onClick={() => setCurrentParticipant(p.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setCurrentParticipant(p.id))}>
                        <UserProfile width="47px" image={p.user.profileImage ? `${p.user.profileImage}` : defaultAvatar} />
                        <div className={classes.ParticipantsName}>{p.user.firstName} {p.user.lastName}</div>
                        {user.id == p.user.id && <div className={classes.MeText}>({texts.me})</div>}
                    </div>)}
            </div>
        </div >
    )


}
export default Participants
